import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { AccountInfo, AuthenticationResult } from "@azure/msal-browser";
import { TranslateService } from "@ngx-translate/core";
import { finalize } from "rxjs/operators";
import { appCommonConstants } from "../app.constants";
import { AppAuthService } from "./auth.service";
import { AppLoggerService } from "./logger.service";

@Injectable({
  providedIn: 'root',
})

// Servizio di autenticazione tramite MSAL (Azure AD B2C)
export class AppAuthMsalService {
  constructor(
    private authService: AppAuthService,
    private logger: AppLoggerService,
    private msalService: MsalService,
    private router: Router,
    private translate: TranslateService) {
  }

  public get isLoading(): boolean {
    return this.$isLoading;
  }
  private $isLoading: boolean = false;

  public init() {
    this.$isLoading = true;

    this.msalService.handleRedirectObservable()
      .subscribe({
        next: (result: AuthenticationResult) => {
          let account: AccountInfo = undefined as any;
          if (result) {
            account = result.account;
          } else {
            // Nessun risultato di redirect (l'utente ha solo ricaricato la pagina)
            // Verifichiamo se c'è già un account in sessione
            const currentAccounts = this.msalService.instance.getAllAccounts();
            if (currentAccounts.length > 0) {
              account = currentAccounts[0];
            }
          }

          this.setLoginData(account);
        },

        error: (error) => {
          this.errorHadler(error);
        }
      });
  }

  /**
   * Impostazione dei dati di login
   * @param account
   */
  public setLoginData(account: AccountInfo): void {
    if (!account) {
      this.$isLoading = false;
      return;
    }

    this.msalService.instance.setActiveAccount(account);

    this.authService.loginData()
      .pipe(finalize(() => {
        this.$isLoading = false;
      }))
      .subscribe({
        next: (x) => {
          this.authService.afterLoginSetData(x);

          // Redirect alla pagina di provenienza o all'homepage configurata
          let homepage = this.authService.redirectUrl ?? x.settings.homePage ?? appCommonConstants.defaultRoutes.home;
          this.authService.redirectUrl = undefined;
          this.router.navigate([homepage]);
        }, error: error => {
          this.errorHadler(error);
        }
      });
  }

  private errorHadler(error: any) {
    this.$isLoading = false;
    let errorMessage = error.message ?? error.descriptionHtml ?? error.description;
    this.logger.error({
      callback: () => {
        this.router.navigate([appCommonConstants.defaultRoutes.loginAzure]);
      }, message: `AppAuthMsalService: init: loginData error ${errorMessage}`, title: this.translate.instant("PROFILE.LOGIN_AZURE")
    });
  }
}
